import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("login") === "true"; // Check if logged in
  // return isAuthenticated ? element : <Navigate to="/online-reg" replace />;
  return isAuthenticated ? element : <Navigate to="/auth/register" replace />;
  // return element;
};

export default ProtectedRoute;
